import React from "react";
import {Typography, Divider} from '@mui/material';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PunchClockIcon from '@mui/icons-material/PunchClock';
import StorageIcon from '@mui/icons-material/Storage';
import DnsIcon from '@mui/icons-material/Dns';

import NavigationButton from "../NavigationButton";
import {NAVIGATION_PATHS} from "../../config/NavigationPaths";

const styles = {
    sectionHeader: {
        fontSize: '0.7rem'
    },
    divider: {
        my: '0.2rem'
    }
};

export default function TrafficMenuSnippet({permissions}) {
    if (!(permissions.canTrafficManage || permissions.canAdmin || permissions.canLiveOps)) {
        return null;
    }

    return (
        <>
            <Typography variant="overline" sx={styles.sectionHeader}>Traffic</Typography>
            <NavigationButton displayName="Live Dashboard" toLink="/live-dashboard">
                <SupportAgentIcon/>
            </NavigationButton>

            {
                (permissions.canTrafficManage || permissions.canAdmin)
                &&
                <>
                    <NavigationButton displayName="Manage Schedule" toLink="/schedule">
                        <PunchClockIcon/>
                    </NavigationButton>
                    <NavigationButton displayName="Schedule Planner" toLink="/plan-schedule">
                        <StorageIcon/>
                    </NavigationButton>
                </>
            }

            {
                (permissions.canTrafficManage || permissions.canLiveOps || permissions.canAdmin)
                &&
                <NavigationButton displayName="Shift Admin" toLink={NAVIGATION_PATHS.SHIFT_ADMIN}>
                    <DnsIcon/>
                </NavigationButton>
            }
            <Divider sx={styles.divider}/>
        </>
    );
}